export const Progress = {
  baseStyle: ({ theme }) => ({
    track: {
      bg: theme.colors.ink.lighter,
    },
  }),
};
